import { FiltersProvider } from 'legacyfrontend/contexts/FiltersContext';
import SearchSelector from 'legacyfrontend/components/home/components/SearchSelector';
import PackagesListView from './PackagesListView';
import { useGlobal } from 'legacyfrontend/contexts/GlobalContext';
import { useState, useEffect, useMemo } from 'react';
import { isClient } from 'legacyfrontend/helpers/ssr-helper';
import { useLocation } from 'react-router-dom';
import { Seo } from 'core/components/seo';
import { useAppName } from 'legacyfrontend/hooks/useSafeState';
import { useSearchShellClientReady } from 'legacyfrontend/hooks/useSearchShellClientReady';

const buildSeoFromParams = (search, appName) => {
  if (!search) {
    return {
      title: appName,
      description: `Encontrá los mejores paquetes turísticos en ${appName}. Compará precios, destinos y fechas. Reservá online.`,
    };
  }

  const params = new URLSearchParams(search);
  const originName = params.get('originName');
  const destinationName = params.get('destinationName');
  const monthYear = params.get('monthYear');

  if (originName && destinationName && monthYear) {
    const [month, year] = monthYear.split('-');
    const monthNames = [
      '', 'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
      'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre',
    ];
    const monthName = monthNames[parseInt(month, 10)] || month;
    const title = appName;
    const description = `Paquetes turísticos desde ${originName} a ${destinationName} para ${monthName} de ${year}. Los mejores precios y financiación en ${appName}.`;
    return { title, description };
  }

  if (originName && destinationName) {
    const title = appName;
    const description = `Paquetes turísticos desde ${originName} a ${destinationName}. Compará precios y fechas disponibles en ${appName}.`;
    return { title, description };
  }

  return {
    title: appName,
    description: `Encontrá los mejores paquetes turísticos en ${appName}. Compará precios, destinos y fechas. Reservá online.`,
  };
};

const PackageListPage = () => {
  const { onSearchCount } = useGlobal();
  const { search } = useLocation();
  const [isMobile, setIsMobile] = useState(false);
  const appName = useAppName();

  const hasValidSearchParams = useMemo(() => {
    if (!search) return false;

    const searchParams = new URLSearchParams(search);
    const hasOrigin = searchParams.get('originId') && searchParams.get('originName');
    const hasDestination = searchParams.get('destinationId') && searchParams.get('destinationName');
    const hasDates = searchParams.get('monthYear');

    return hasOrigin && hasDestination && hasDates;
  }, [search]);

  const seoData = useMemo(() => buildSeoFromParams(search, appName), [search, appName]);
  const isClientReady = useSearchShellClientReady(hasValidSearchParams);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(isClient ? window.innerWidth <= 768 : false);
    };
    handleResize();
    isClient && window.addEventListener('resize', handleResize);
    return () => isClient && window.removeEventListener('resize', handleResize);
  }, []);

  const shouldShowFilters = onSearchCount > 0 || hasValidSearchParams;

  return (
    <>
      <Seo {...seoData} />
      {isClientReady ? (
        <FiltersProvider>
          <SearchSelector isOnTargetPath />
          {shouldShowFilters && <PackagesListView />}
        </FiltersProvider>
      ) : (
        <h1 className='sr-only'>Buscar paquetes turísticos</h1>
      )}
    </>
  );
};

export default PackageListPage;
